import { render, staticRenderFns } from "./TooltipUeberspannungsschutzkonzept.vue?vue&type=template&id=c3283f48&scoped=true&"
import script from "./TooltipUeberspannungsschutzkonzept.vue?vue&type=script&lang=js&"
export * from "./TooltipUeberspannungsschutzkonzept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3283f48",
  null
  
)

export default component.exports